import * as CubeTree from '../../../cubeTree/index';
import Utils from '../../../utils/util';
import CodiSystem from '../../../codiSystem/index';
import { cubeModify } from '../../../update/cubeModify';
import { updateCubeList } from '../../../update/updateCubeList';
import { updateEnd } from '../../../update/updateEnd';
import { moveSelected } from '../moveSelected/index';
import { insertToStagePosition } from '../insertToStagePosition';

function partitionInsertAfter(beAddedCube: CubeNode, task: InsertInfo): void {
    let updateData: FreeObjMap = {};

    // 坐标系统增加插入对象
    CodiSystem.add(beAddedCube.id);
    addPositionKeys(updateData, beAddedCube, task);
    cubeModify(beAddedCube.id, updateData);
    updateCubeList([findUpdateTarget(beAddedCube.id)]);
    updateEnd();

    // 移动选择器选中态
    moveSelected(beAddedCube, task);
}

function addPositionKeys(updateData: FreeObjMap, beAddedCube: CubeNode, task: InsertInfo): void {
    // 插入货架时溢出
    if (CubeTree.isSketchpad(task.targetId)
        && task.extendParams
        && task.extendParams.isOverflowShelf) {
        let insertPosition: PhysicsPosition = insertToStagePosition(beAddedCube.id);

        updateData.posX = insertPosition.left;
        updateData.posY = insertPosition.bottom;
        return;
    }

    // 如果是跨商家复制，粘贴对象是画布，则使用复制坐标即可
    if (CubeTree.isSketchpad(task.targetId)
        && task.extendParams
        && task.extendParams.addType === 'copy'
        && task.extendParams.diffBusiness) {
        updateData.posX = task.extendParams.originalCubePhysicsCoordinate.left;
        updateData.posY = task.extendParams.originalCubePhysicsCoordinate.bottom;
        return;
    }

    // 复制新增, 往画布中插
    if (CubeTree.isSketchpad(task.targetId)
        && task.extendParams
        && task.extendParams.addType === 'copy') {
        let left: PhysicsMeasurement = Utils.math(task.extendParams.originalCubePhysicsCoordinate.left, 5, '+');
        let bottom: PhysicsMeasurement = Utils.math(task.extendParams.originalCubePhysicsCoordinate.bottom, 5, '+');

        updateData.posX = left;
        updateData.posY = bottom;
        return;
    }

    // 常规新增，往画布中插
    if (CubeTree.isSketchpad(task.targetId)
        && task.extendParams
        && task.extendParams.addType === 'normal') {
        let insertPosition: PhysicsPosition = insertToStagePosition(beAddedCube.id);

        updateData.posX = insertPosition.left;
        updateData.posY = insertPosition.bottom;
        return;
    }

    // 使用计算出的插入坐标
    if (task.physicsRelativePosition) {
        updateData.posX = task.physicsRelativePosition.left;
        updateData.posY = task.physicsRelativePosition.bottom;
    }
}

function findUpdateTarget(cubeId: CubeId): CubeId {
    if (CubeTree.isInStage(cubeId)) {
        return cubeId;
    }

    let itsShelf: CubeId = CubeTree.findCubeShelf(cubeId);

    return itsShelf;
}

export {
    partitionInsertAfter
};
